define([
  'lib/sumome/service/index',
  'articles',
  'moment',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/welcomemat/popup',
], (SumoService, Articles, moment, WelcomeMatPopup) => {

  class WelcomeMatService extends SumoService.Service {
    static SHOWN_COOKIE = '__smWelcomeMatShown';
    static OPT_OUT_COOKIE = '__smWelcomeMatOptOut';

    static EMBEDDED_SHOWN_COOKIE = '__smWelcomeMatEmbeddedShown';

    constructor(api, service, welcomemat, opts = {}) {
      super(api);

      if (welcomemat && opts.isPreview) {
        this.mat = new WelcomeMatPopup(this, {
          ...welcomemat,
          isPreview: true,
        });

        return this.onShow(null, this.mat);
      }

      this.fetchFeatures().then(() => {
        this.service = service;
        this.mat = new WelcomeMatPopup(this, welcomemat);
        this.lastScrollTop = 0;

        this.onClose = this.onClose.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollEmbedded = this.onScrollEmbedded.bind(this);
        this.onScrollParallax = this.onScrollParallax.bind(this);

        this.calculateParallaxScrollMultiplier = this.calculateParallaxScrollMultiplier.bind(this);

        // Cookie function initializations
        this.setOptOutCookie = this.service.setOptOutCookie.bind(this, WelcomeMatService.OPT_OUT_COOKIE);
        this.setShownCookie = this.service.setShownCookie.bind(this, WelcomeMatService.SHOWN_COOKIE);
        this.setEmbeddedShownCookie = this.service.setShownCookie.bind(this, WelcomeMatService.EMBEDDED_SHOWN_COOKIE);
        this.setCtaCookie = this.service.setCtaCookie.bind(this);
        this.setSubscribedCookie = this.service.setSubscribedCookie.bind(this);

        this.parallaxScrollMultiplier = 2.4;

        this.onShow();
      });
    }

    calculateParallaxScrollMultiplier() {
      this.parallaxScrollMultiplier = (this.mat.anchorPosition + window.innerHeight + 10) / (Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight);
      this.parallaxScrollMultiplier = Math.max(this.parallaxScrollMultiplier, 2.4);
    }

    onShow() {
      this.mat.show();

      switch(this.mat.settings.get('display_mode')) {
        case 'normal':
          this.addEvent(document, 'scroll', this.onScroll);
          break;
        case 'embedded':
          this.addEvent(document, 'scroll', this.onScrollEmbedded);
          break;
        case 'parallax':
          this.calculateParallaxScrollMultiplier();
          this.addEvent(document, 'scroll', this.onScrollParallax);
          this.onScrollParallax();
          break;
      }

      this.addEvent(window, 'resize', this.onResize);
    }

    removeEvents() {
      this.removeEvent(document, 'scroll', this.onScroll);
      this.removeEvent(document, 'scroll', this.onScrollEmbedded);
      this.removeEvent(document, 'scroll', this.onScrollParallax);
      this.removeEvent(window, 'resize', this.onResize);
    }

    onClose() {
      // Trigger onClose on main service so other form types can show.
      this.removeEvents();
      if (this.mat.settings.get('display_mode') === 'normal') this.service.onCloseWelcomeMat();
      this.api.emit('156085c5-0017-4150-b225-a731ad248f38/service/welcomemat/intent/close');
    }

    onResize() {
      this.mat.onResize();

      if (this.mat.settings.get('display_mode') === 'parallax') {
        this.calculateParallaxScrollMultiplier();
      }
    }

    onScroll() {
      const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);

      // If landing page, check that class is still applied to `html`
      if (this.mat.settings.get('is_landing_page')) {
        const bodyClassName = document.body.className;
        const htmlClassName = document.documentElement.className;

        if (htmlClassName.indexOf('sumome-welcome-mat-landing-page') === -1) {
          document.documentElement.className += ' sumome-welcome-mat-landing-page';
        }

        if (bodyClassName.indexOf('sumome-welcome-mat-landing-page') === -1) {
          document.documentElement.className += ' sumome-welcome-mat-landing-page';
        }

        if (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) {
          window.scrollTo(0, 0);
        }
      }

      if (scrollTop > window.innerHeight) {
        // Close mat
        this.mat.close();
      }
    }

    onScrollEmbedded() {
      if (this.mat.isFooter) return;
      const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      const mat = document.querySelector('.welcome-mat-popup');
      const offsetTop = mat.offsetTop;

      if (this.mat.settings.get('is_landing_page') && scrollTop > offsetTop) {
        window.scrollTo(0, offsetTop);
        return;
      }

      if (scrollTop >= offsetTop && this.lastScrollTop <= offsetTop && this.lastScrollTop < scrollTop) {
        // Scrolled below welcome mat
        const newTop = this.mat.anchorPosition - window.innerHeight - 2;
        mat.style.top = `${newTop}px`;
        window.scrollTo(0, newTop + 1);
        this.lastScrollTop = newTop + 1;
      } else if (scrollTop <= offsetTop && this.lastScrollTop > offsetTop && this.lastScrollTop > scrollTop) {
        // Scrolled above welcome mat
        const newTop = this.mat.anchorPosition - 2;
        mat.style.top = `${newTop}px`;
        window.scrollTo(0, newTop);
        this.lastScrollTop = newTop;
      } else {
        this.lastScrollTop = scrollTop;
      }
    }

    onScrollParallax() {
      if (this.mat.isFooter) return;
      const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      this.mat.popupEl.scrollTop = scrollTop * this.parallaxScrollMultiplier;
    }
  }

  return WelcomeMatService;
});
